// TM Consulting Azure portal-related constants
export const TAX_CONSTANTS = {
  PROTESTFUND: {
    MIN: 7410,
    MAX: 7449,
  },

};
export const PROTEST_TAX_TYPES = ['M', 'P', 'B'];

export const EXEMPT_STATUS_CONSTANTS = 406;

export const SEARCH_DEBOUNCE_TIMER = 1000;

export const POST_LOAD_COMP_TIMER = 100;

// A tax-year/tax-id lookup that never comes back would otherwise hold the payment grid's
// in-flight guard forever - the GraphQL client is built without any timeout at all
// (createHttpLink with no fetchOptions), so a stalled request simply never settles.
export const TAX_LOOKUP_TIMEOUT_MS = 20000;

export const REGEX_VALIDATION = {
  onlyAlphabets: /^[a-zA-Z ]+$/,
  alphaWithSpeCha: /^[a-zA-Z, ]+$/, // ex: for owner names
  alphaNumerics: /^[a-zA-Z0-9 ]+$/,
  alphaNumericsWithSomeSpeChar: /^[-a-zA-Z0-9., ]+$/, // ex: for address
  onlyNumWithSomeSpeChar: /^[0-9,. ]+$/,
  onlyNumerics: /^[0-9]+$/,
};
export const MIN_ALLOW_AMT_HALF = 25;

export const DEFAULT_MIN_TAX_YEAR = 2018;

export default {};
